import { defineMessages } from 'react-intl';

export const myLibrarySubmenuMessages = defineMessages({
  myLibrary: {
    defaultMessage: 'My library', id: 'ZUGLwxXdXf',
    description: 'Label for the My Library source control submenu',
  },
  myLibraryMenuLabel: {
    defaultMessage: 'My library sources', id: '26v5VxJqoM',
    description: 'Accessible label for the My Library submenu button',
  },
  selectedCount: {
    defaultMessage: '{count, plural, one {# selected} other {# selected}}', id: 'Qo0bhdVTwQ',
    description:
      'Summary shown when more than two collections are selected in the My Library submenu',
  },
  uncollectedDocuments: {
    defaultMessage: 'Not in a collection', id: 'XV1fd78Jp2',
    description: 'Label for documents that are not assigned to any collection',
  },
  uncollectedDocumentsDescription: {
    defaultMessage: 'Documents not assigned to any collection', id: 'C+gEeHYjli',
    description: 'Description for the uncollected documents toggle',
  },
  goToLibrary: {
    defaultMessage: 'Create a collection', id: '/7Ef5fo9xx',
    description: 'Action to navigate to the library to create a new collection',
  },
  librarySearchPlaceholder: {
    defaultMessage: 'Search collections\u2026', id: 'aew+N5uQg9',
    description: 'Placeholder for the collection search input in My Library submenu',
  },
  noResults: {
    defaultMessage: 'No results', id: 'Lf9JVyn+Wc',
    description: 'Empty state when collection search returns nothing',
  },
  managedByTeamAdmin: {
    defaultMessage: 'Some sources are required by {teamName}', id: 'nb7IQu/P9P',
    description:
      'Notice that some sources are enforced by the team admin',
  },
  documentCount: {
    defaultMessage: '{count, plural, one {# document} other {# documents}}', id: 'nns64+mOGj',
    description: 'Number of documents in a library collection',
  },
  domainCount: {
    defaultMessage: '{count, plural, one {# source} other {# sources}}', id: 'eXef8XLK3D',
    description: 'Number of trusted sources in a web collection',
  },
});
